var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":"","variant":"secondary"}},[_c('h4',[_vm._v("When you joined ORBITA-2, you told us:")]),_vm._v(" "),_c('h4',[_vm._v("My angina is "),_c('strong',[_vm._v(_vm._s(_vm.text || "** INFORMATION MISSING ** Please call the ORBITA HQ helpline and tell them that your angina description has not yet been set up"))]),_vm._v(".")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65f2fc34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyAnginaIs.vue
// module id = 480
// module chunks = 1